import { lazy, ReactNode, Suspense } from "react";

const LandingPage = lazy(() => import("./LandingPage"));

// "/" без токена — маркетинговый лендинг (cognimbus.med); с токеном — кабинет
export default function HomeGate({ app }: { app: ReactNode }) {
  let hasToken = false;
  try {
    hasToken = !!localStorage.getItem("token");
  } catch {
    /* storage недоступен — показываем лендинг */
  }
  if (hasToken) return <>{app}</>;
  return (
    <Suspense fallback={null}>
      <LandingPage />
    </Suspense>
  );
}
